export const AppChannel = {
  VecchiaApr: 0,
  PortaleWebWwwSisalIt: 1,
  PortaleGiochiNumerici: 2,
  MSiteMSisalIt: 3,
  Totem: 4,
  MSiteScommesse: 5,
  AppMobileMobileSisalIt: 6,
  AppMobileLitGrattaEVinci: 7,
  AppMobileGame360: 8,
  ClientBingo: 9,
  ClientPoker: 10,
  SkillGamesGameAccount: 11,
  ClientCasinoGamesPt: 12,
  QuickGamesWeb: 13,
  NonAuthoritativeSites: 14,
  SkillGamesLtmWeb: 15,
  CasinoGamesGameAccount: 16,
  PortaleLoyaltyKeyos: 17,
  PortaleGiochiNumerici2: 18,
  QuickGamesMobile: 19,
  WebLotto10ELotto: 20,
  MobileLotto10ELotto: 21,
  WebVirtualRacesOnline: 22,
  AppMobileSuperenalotto: 24,
  MobileSiteCasinoGamesGameAccount: 25,
  SkillGamesLtmMobile: 26,
  AppMobileLitGrattaEVinci2: 28,
  AppFantasySlotGame360: 29,
  AppMobileVirtualRace: 30,
  MobileClientCasinoGamesPt: 31,
  AppMobileVinciCasa: 32,
  AppMobileCasinoGamesViaden: 33,
  ClientCasinoActiveGames: 34,
  AppMobileMobileSisalItIpad: 35,
  CasinoGamesGiocaOnLine: 36,
  AppMobileNativeCasinoAppPlaytech: 37,
  AppMobileClassicSlotGameAccount: 38,
  AppMobileLiveScoreScoreAlarm: 39,
  CasinoGamesGame360: 40,
  PlaytechNativePokerApp: 41,
  IppicaBetflag: 42,
  MobileCasinoGamesGame360: 43,
  AppMobileEuroJackpot: 44,
  AppMobileBingo: 45,
  MediasetDtt: 46,
  AppMobileRouletteGameAccount: 47,
  AppMobileCasinoGamesGame360Macau: 48,
  AppRouletteGiocaOnLine: 49,
  RouletteGiocaOnLineMsite: 50,
  AppMobileScommesse: 51,
  GamificationPugPharmDesktop: 52,
  GamificationPugPharmMobile: 53,
  AppLottery: 54,
  AppCasinoHub: 55,
  MobileSiteVirtualRace: 56,
  MobileSitePoker: 57,
  AppSisalGame360: 59,
  MobileSiteBetflag: 60,
  AppMobileBetflag: 61,
  PortaleWebFullResponsiveWwwSisalIt: 62,
  AppMobileLdtLotteriaItalia: 63,
  SisalFunClub: 64,
  SalvaIlBottino: 65,
  ClientDesktopSisalPoker: 67,
  AppSisalPoker: 68,
  AppCasinoSnai: 69,
} as const

export function getChannelFromSiteIdString(siteId?: string | null): Channel {
  const channel = siteId != null ? parseInt(siteId, 10) : null
  // Defaults to PortaleWebFullResponsiveWwwSisalIt
  if (channel == null || isNaN(channel)) {
    return AppChannel.PortaleWebFullResponsiveWwwSisalIt
  }
  return channel as Channel
}

export function getChannelFromSearchParams(searchParams: {
  [key: string]: string | string[] | undefined
}): Channel {
  const siteid =
    typeof searchParams.siteid === "string" ? searchParams.siteid : undefined
  return getChannelFromSiteIdString(siteid)
}

export type Application = keyof typeof AppChannel
export type Channel = (typeof AppChannel)[Application]
